import { Injectable } from "@angular/core";

import { ApiTemplate } from "../base/template/api.template";
import { Role, RoleRequest } from "./model/role.model";

@Injectable({ providedIn: 'root' })
export class RoleApi extends ApiTemplate<Role, RoleRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/roles");
    }
}
